export const feelYourJourneyData = [
  "Easy Payment Systems.",
  "Make safety a top priority.",
  "First and quick pickups.",
  "Access Go Vahan globally.",
];
